import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { CorePageParams } from 'site-modules/shared/utils/core-page/params';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { SubmodelDropdown } from './submodel-dropdown';
import { YearDropdown, YearDropdownGraphql } from './year-dropdown';
import { ModelFamilyDropdown, ModelFamilyDropdownGraphql } from './model-family-dropdown';
import { TypeDropdown, TypeDropdownGraphql } from './type-dropdown';

import './year-submodel-controls.scss';

const DESCRIPTION_ID = 'year-submodel-description';

export function YearSubmodelControls({
  params,
  vehicle,
  isUsed = false,
  isPreprod = false,
  isCore7661Enabled = false,
  isCore7646Enabled = false,
}) {
  const selectedYearId = `${vehicle.modelYearId}`;
  const selectedSubmodelId = `${vehicle.year}|${vehicle.submodels.slug}`;
  const selectedModelSlug = `${vehicle.model.slug}`;
  const selectedType = `${vehicle.year}|${vehicle.make.slug}|${vehicle.model.slug}|${vehicle.submodels.slug}`;
  const YearDropdownComponent = isCore7661Enabled || isCore7646Enabled ? YearDropdownGraphql : YearDropdown;
  const ModelFamilyDropdownComponent = isCore7661Enabled ? ModelFamilyDropdownGraphql : ModelFamilyDropdown;
  const TypeDropdownComponent = isCore7661Enabled ? TypeDropdownGraphql : TypeDropdown;

  return (
    <div className="year-submodel-controls d-flex justify-content-between align-items-start">
      <span id={DESCRIPTION_ID} className="visually-hidden">
        Changing {isUsed ? 'year' : 'year or type'} will take you to a new page
      </span>
      <YearDropdownComponent
        descriptionId={DESCRIPTION_ID}
        params={params}
        modelName={vehicle.model.name}
        value={selectedYearId}
        modelFamilyIds={isCore7661Enabled || isCore7646Enabled ? vehicle?.modelFamilyIds : undefined}
      />
      {!isUsed && !isPreprod && (
        <FeatureFlag name="core-7707-type-dropdown">
          {enabled =>
            enabled ? (
              <TypeDropdownComponent
                descriptionId={DESCRIPTION_ID}
                params={params}
                value={selectedType}
                skipModelFamily={params.isTruck}
                modelFamilyIds={isCore7661Enabled ? vehicle.modelFamilyIds : undefined}
              />
            ) : (
              <Fragment>
                <SubmodelDropdown descriptionId={DESCRIPTION_ID} params={params} value={selectedSubmodelId} />
                {!params.isTruck && (
                  <ModelFamilyDropdownComponent
                    descriptionId={DESCRIPTION_ID}
                    params={params}
                    value={selectedModelSlug}
                    modelFamilyIds={isCore7661Enabled ? vehicle.modelFamilyIds : undefined}
                  />
                )}
              </Fragment>
            )
          }
        </FeatureFlag>
      )}
    </div>
  );
}

YearSubmodelControls.propTypes = {
  params: CorePageParams.isRequired,
  vehicle: VehicleEntities.MakeModelSubmodelYear.isRequired,
  isUsed: PropTypes.bool,
  isPreprod: PropTypes.bool,
  isCore7661Enabled: PropTypes.bool,
  isCore7646Enabled: PropTypes.bool,
};
